import React, { createContext, useState } from 'react'

export const OpenAPIResponseContext = createContext({})

export const OpenAIConnectionResponseWrapper = ({ children }) => {
  const [response, setResponse] = useState({})

  return <OpenAPIResponseContext.Provider value={{ response, setResponse }}>{children}</OpenAPIResponseContext.Provider>
}
